import React from 'react';
import PropTypes from 'prop-types';

import { FormControlLabel as MUIFormControlLabel } from '@material-ui/core';

export const FormControlLabel = props => <MUIFormControlLabel {...props} />;

FormControlLabel.propTypes = {
  classes: PropTypes.object,
  control: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.node,
  labelPlacement: PropTypes.oneOf(['end', 'start', 'top', 'bottom']),
  style: PropTypes.object,
  value: PropTypes.any   // eslint-disable-line react/forbid-prop-types
};

export default FormControlLabel;
